import "./module/userAgentChecker.min.js"
import "./module/plugin.js"

import Swiper from 'swiper/bundle';
var swiper01 = new Swiper('.mv__slider', {
    centeredSlides: true,
    loop: true,
    speed: 2500,
    effect: "fade",
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    }
});

var galleryThumbs = new Swiper('.store__innerFlexContentSingleImgThumbs', {
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});
var galleryTop = new Swiper('.store__innerFlexContentSingleImgSlider', {
    centeredSlides: true,
    spaceBetween: 10,
    thumbs: {
      swiper: galleryThumbs
    }
});

var swiper02 = new Swiper('.store__innerFlexContentRelatedSlider', {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      667: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

import objectFitImages from 'object-fit-images';
objectFitImages();

(function(d) {
    var config = {
      kitId: 'lha5bkz',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);